__turbopack_context__.v({
  "className": "dm_mono_fb70b56c-module__1z09cW__className",
});
